import "./index.scss";
import AnimatedLetters from "../AnimatedLetters";
import { useEffect, useState } from "react";
import { UserCard } from "react-ui-cards";
import TitaBG from "../../assets/images/tita_bg.png";
import TitaLogo from "../../assets/images/tita_logo.png";
import FLBG from "../../assets/images/firstlight_bg.png";
import FLLogo from "../../assets/images/firstlight_logo.png";
import BuddyBG from "../../assets/images/buddycare_bg.png";
import BuddyLogo from "../../assets/images/buddycare_logo.png";
import {
    FaReact,
    FaNode,
    FaPython,
    FaExternalLinkAlt,
    FaCode,
    FaBackward,
    FaRegNewspaper,
} from "react-icons/fa";
import {
    SiMongodb,
    SiSelenium,
    SiMaterialui,
    SiFirebase,
    SiRedux,
    SiMysql,
} from "react-icons/si";

const Projects = () => {
    const [letterClass, setLetterClass] = useState("text-animate");
    const [activeCard, setActiveCard] = useState(null);

    useEffect(() => {
        setTimeout(() => {
            setLetterClass("text-animate-hover");
        }, 4000);
        return () => {
            console.log("This will be logged on unmount");
        };
    }, []);

    const handleClick = (e) => {
        let idx = e - 1;
        let cards = document.getElementsByClassName(
            "src-UserCard-styles-module__card-link--1C9Mt"
        );

        for (let i = 0; i < 3; i++) {
            cards[i].classList.add("skills-card-disabled");
        }

        setActiveCard(idx + 1);

        document
            .getElementsByClassName("skills-modal-disabled")[0]
            .classList.add("skills-modal");
        document
            .getElementsByClassName("skills-modal-disabled")[0]
            .classList.remove("skills-modal-disabled");
    };

    const closeModal = () => {
        document
            .getElementsByClassName("skills-modal")[0]
            .classList.add("skills-modal-disabled");
        document
            .getElementsByClassName("skills-modal-disabled")[0]
            .classList.remove("skills-modal");

        let cards = document.getElementsByClassName(
            "src-UserCard-styles-module__card-link--1C9Mt"
        );

        for (let i = 0; i < 3; i++) {
            cards[i].classList.remove("skills-card-disabled");
            cards[i].classList.add("skills-card");
        }
    };

    return (
        <div className="container projects-page">
            <div className="text-zone">
                <h1>
                    <AnimatedLetters
                        strArray={Array.from("My ")}
                        idx={15}
                        letterClass={letterClass}
                    />
                </h1>
                <h1>
                    <AnimatedLetters
                        strArray={Array.from("Projects")}
                        idx={20}
                        letterClass={letterClass}
                    />
                </h1>
                <div className="subtext-zone">
                    <UserCard
                        float
                        header={FLBG}
                        avatar={FLLogo}
                        name="FirstLight"
                        positionName="A Positive News Initiative"
                        stats={[
                            { name: "", value: "Web Development" },
                            { name: "", value: "Machine Learning" },
                        ]}
                        className="skills-card"
                        onClick={() => handleClick(1)}
                    />
                    <UserCard
                        float
                        header={BuddyBG}
                        avatar={BuddyLogo}
                        name="BeSure BuddyCare"
                        positionName="COVID Health Center Manager"
                        stats={[
                            { name: "", value: "Web Development" },
                            { name: "", value: "Databases" },
                        ]}
                        className="skills-card"
                        onClick={() => handleClick(2)}
                    />
                    <UserCard
                        float
                        header={TitaBG}
                        avatar={TitaLogo}
                        name="TiTa"
                        positionName="Classroom Management System"
                        stats={[
                            { name: "", value: "Web Development" },
                            { name: "", value: "Databases" },
                        ]}
                        className="skills-card"
                        onClick={() => handleClick(3)}
                    />

                    <div className="skills-modal-disabled">
                        {activeCard && activeCard === 1 ? (
                            <div className="skills-modal-item">
                                <div className="skills-modal-item-info">
                                    <span
                                        onClick={closeModal}
                                        className="skills-modal-close-container"
                                    >
                                        <FaBackward className="skills-modal-close" />
                                        Go Back
                                    </span>
                                    <h2>
                                        FirstLight - A Positive News Initiative
                                    </h2>
                                    <h3>
                                        Technologies Used:{" "}
                                        <span className="tech-icons">
                                            <FaReact />
                                            <FaNode />
                                            <FaPython />
                                            <SiMongodb />
                                            <SiSelenium />
                                            <SiMaterialui />
                                        </span>
                                    </h3>
                                    <hr />
                                    <p>
                                        FirstLight is an application that aims
                                        to provide people with positive news to
                                        make their day better. FirstLight
                                        ensures its users always receive news
                                        that carries a positive tone. This is an
                                        effort to ensure a healthy and
                                        productive mind which in turn leads to a
                                        person’s holistic growth. <br />
                                        Choose how positive the news should be
                                        for you. Download it on your mobile or
                                        desktop with PWA support. Enjoy news
                                        from your favorite news sources such as
                                        BBC, CNN, NDTV and TechCrunch. Play the
                                        traditional newspaper games such as
                                        Sudoku, Maze and TicTacToe or solve them
                                        using AI. Read your favorite comics such
                                        as Dilbert, Garfield, Calvin and Hobbes
                                        and many more.
                                    </p>
                                    <span className="skill-buttons">
                                        <a
                                            href="https://github.com/FirstLight-A-positive-news-initiative"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <button>
                                                Source Code <FaCode />{" "}
                                            </button>
                                        </a>
                                        <a
                                            href="https://www.firstlight.live/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <button>
                                                View Live <FaExternalLinkAlt />{" "}
                                            </button>
                                        </a>
                                    </span>
                                </div>
                                <img src={FLBG} alt="Firstlight" />
                            </div>
                        ) : (
                            <></>
                        )}
                        {activeCard && activeCard === 2 ? (
                            <div className="skills-modal-item">
                                <div className="skills-modal-item-info">
                                    <span
                                        onClick={closeModal}
                                        className="skills-modal-close-container"
                                    >
                                        <FaBackward className="skills-modal-close" />
                                        Go Back
                                    </span>
                                    <h2>BeSure BuddyCare</h2>
                                    <h3>
                                        Technologies Used:
                                        <span className="tech-icons">
                                            <FaReact />
                                            <SiFirebase />
                                            <SiRedux />
                                        </span>
                                    </h3>
                                    <hr />
                                    <p>
                                        BeSure BuddyCare is a user-friendly web
                                        application, created for paperless
                                        management of mini-Covid care centres
                                        set up in Chandigarh. The app
                                        accommodates the information of
                                        patients, doctors, nurses and families
                                        at centres. Additional features of the
                                        software include updates on crucial
                                        administrative data such as the number
                                        of available beds, record updates of the
                                        nursing staff and attendants and other
                                        description. <br />
                                        Through the platform, patients could be
                                        registered at the centre at the time of
                                        admission, their daily vitals could be
                                        recorded and regularly updated on the
                                        platform, which could be used for
                                        treatment and monitoring by the doctors
                                        and other health professionals.
                                    </p>
                                    <span className="skill-buttons">
                                        <a
                                            href="https://www.tribuneindia.com/news/chandigarh/paperless-mgmt-of-care-centres-251975"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <button>
                                                View News Article{" "}
                                                <FaRegNewspaper />{" "}
                                            </button>
                                        </a>
                                    </span>
                                </div>
                                <img src={BuddyBG} alt="BeSure BuddyCare" />
                            </div>
                        ) : (
                            <></>
                        )}
                        {activeCard && activeCard === 3 ? (
                            <div className="skills-modal-item">
                                <div className="skills-modal-item-info">
                                    <span
                                        onClick={closeModal}
                                        className="skills-modal-close-container"
                                    >
                                        <FaBackward className="skills-modal-close" />
                                        Go Back
                                    </span>
                                    <h2>TiTa - Classroom Management System</h2>
                                    <h3>
                                        Technologies Used:
                                        <span className="tech-icons">
                                            <FaReact />
                                            <FaNode />
                                            <SiRedux />
                                            <SiMysql />
                                        </span>
                                    </h3>
                                    <hr />
                                    <p>
                                        TiTa aims at bridging the gap between
                                        teachers and students by creating an
                                        online interactive environment. Teachers
                                        can create classrooms, share
                                        assignments, resources, schedule
                                        quizzes, and set timetables. On the
                                        other end, Students can join classrooms
                                        using unique classroom codes, keep a
                                        check on their weekly schedule, view and
                                        submit solutions to assignments. They
                                        can also track their performance with
                                        analysis for each quiz they take. They
                                        can access their To-Do List to check all
                                        things that are due, completed, or
                                        missed. <br /> All this, with a
                                        beautiful UI and an option to install it
                                        on your desktop and mobile.
                                    </p>
                                    <span className="skill-buttons">
                                        <a
                                            href="https://github.com/TiTa-Classroom-Management-System"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <button>
                                                View Source Code <FaCode />{" "}
                                            </button>
                                        </a>
                                        <a
                                            href="https://tita-app.netlify.app/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <button>
                                                View Live <FaExternalLinkAlt />{" "}
                                            </button>
                                        </a>
                                    </span>
                                </div>
                                <img src={TitaBG} alt="TiTa" />
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Projects;
